import React, { useEffect, useState } from "react";
import DesktopMenu from "../../../common/DesktopMenu/index";
import MobileMenu from "../../../common/MobileMenu/index";
import useWindowSize from "../../../common/windowSize";
import NewFooter from "../../../common/NewFooter";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import BackButton from "../../Products/BackButton";
import { publicAPI } from "../../../utils/api";
import { 
  Form,
} from "./styles";
import { 
  Background, 
} from "../../../common/Faq/styles";
import {
  SettingsHeader,
  Title
} from '../styles';

const ContactUs = () => {
  const size = useWindowSize();
  const [messageBody, setMessageBody] = useState({});
  const [mobileMenu, setMobileMenu] = useState(false);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const sendMessage = async (event) => {
    event.preventDefault();
    setLoading(true)

    if(!messageBody.name) return [toast.info('Name is empty'), setLoading(false)];
    if(!messageBody.email) return [toast.info('Email is empty'), setLoading(false)];
    if(!messageBody.phone) return [toast.info('Phone is empty'), setLoading(false)];
    if(!messageBody.message) return [toast.info('Massage is empty'), setLoading(false)];

    try {
        const emailDTO = messageBody;
        await publicAPI.post('/public/bacchus/contactus', emailDTO);
        let messageForm = document.getElementById('message-form')
        messageForm.reset();
        setLoading(false);
        toast.success('Message is sent. Thank you!');
    } catch (error) {
        toast.info('Currently we cannot receive message.');
        setLoading(false);
    }
  }

  const setMessageData = (value, attributes) => {
      setMessageBody({
          ...messageBody, 
          [attributes]: value
      })
  }

  useEffect(() => {
    if (size.width < 1200) {
      setMobileMenu(true);
    } else {
      setMobileMenu(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [size]);

  return (
    <>
      {mobileMenu ? <MobileMenu single={true}/> : <DesktopMenu single={true}/> }
      <Background marginTop adminPanel>
        <SettingsHeader>
          <BackButton userPanel/>
          <Title>Contact Us</Title>
        </SettingsHeader>
        <Form id="message-form">
          <div>
            <label htmlFor="name">{t("name")}</label>
            <input 
              type="text" 
              id="name" 
              required 
              onChange={(e) => setMessageData(e.target.value, 'name')}
              placeholder="Enter your name"
              disabled={loading}
              />
          </div>
          <div>
            <label htmlFor="email">{t("email")}</label>
            <input 
              type="text" 
              id="email" 
              required 
              onChange={(e) => setMessageData(e.target.value, 'email')}
              placeholder="Enter your email"
              disabled={loading}
              />
          </div>
          <div>
            <label htmlFor="phone">{t("phone")}</label>
            <input 
              type="text" 
              id="phone" 
              required 
              onChange={(e) => setMessageData(e.target.value, 'phone')}
              placeholder="Enter your phone"
              disabled={loading}
              />
          </div>
          <div>
            <label htmlFor="message">{t("typeYourMessage")}</label>
            <textarea 
              cols="30" 
              rows="10" 
              id="message" 
              style={{resize: 'none'}} 
              required 
              onChange={(e) => setMessageData(e.target.value, 'message')}
              placeholder="Enter your message"
              disabled={loading}
              >
            </textarea>
          </div>
          <button onClick={(e) => sendMessage(e)}>{loading ? `${t("loading")}...` : t("send")}</button>
        </Form>
      </Background>
      <NewFooter />
      <Backdrop sx={{ color: "#fff", zIndex: 1000 }} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default ContactUs;
